// Canonical prompt text for every card in CONSTELLATION_PROMPTS (AIChat.js).
// The library greys out (disables) any card whose key is missing here, so this
// map must stay in step with CONSTELLATION_PROMPTS — it is the single source
// for both the full AI Assistant page and the floating launcher/dock.
const HIGHLIGHT_PROMPTS = {
  // Market rates — live comp-set rate shops (v2 agent, SerpApi-backed)
  compTonight: "Rate shop tonight: how are we priced versus our comp set for tonight, and does our on-the-books occupancy justify that position?",
  compWeekend: "Check our rates for this weekend against the comp set, night by night. Blend in our OTB pickup and flag any night where our rate position may be hurting bookings.",
  softWeekRates: "Find my softest booking nights in the next two weeks, rate shop the worst ones against the comp set, and tell me whether price looks like the problem or demand is just light.",

  // Automations — recurring tasks the assistant sets up itself
  anomalyEmail: "Email me every morning at 7am with any unusual booking activity — pickup spikes, cancellation clusters, or future dates priced far off last year. Set this up as a recurring task.",
  anomalyScan: "Scan future dates for unusual booking activity — spikes, cancellation clusters, and nights priced far off last year — and tell me which ones need action today.",

  // Financial forensics
  gopFlow: "Calculate GOP flow-through for last month and tell me whether cost controls protected our margin. Call out the departments that drove the miss.",

  // Daily ops
  dailyBriefing: "Show me what I need to know for today.",
  revenuePerformance: "Show me yesterday's occupancy and revenue performance compared to the same day last week. Include ADR, RevPAR, and total revenue breakdown by segment.",

  // Revenue
  marketSegmentMTD: "What's our market segmentation revenue month to date?",
  adrOccupancyTrend: "Show me ADR and occupancy together for the last 30 days.",
  dailyRevenue30d: "Show me daily revenue for the last 30 days.",

  // Financial performance
  budgetVsLastMonth: "How did we perform vs budget last month?",
  financialPerformance: "Give me a full financial performance summary for last month — revenue vs budget, total expenses vs budget, and net income. Flag any departments significantly over or under budget.",
  budgetVariance: "Show me last month's P&L with budget variances. Drill into the top expense line items that missed budget and tell me which vendors or transactions caused the variance.",

  // Expenses
  expenseOutliers: "Show me expense outliers for last month compared to historicals.",
  topVendors: "Who are our top 5 vendors by spend last month?",

  // Forecast / OTB
  forecastOTB: "What does the on-the-books forecast look like for the next 30 days? Show me OTB and projected occupancy, revenue, and ADR side by side.",
  otbPickup: "How much did our OTB revenue pickup for the next 7 days since last week?",
  monthEndRoomsPacing: "At our current run rate, where does rooms revenue end up this month vs budget?",

  // Labor
  laborAnalysis: "Analyze our labor costs for this month. Show me HPOR, DPOR, overtime percentage, and payroll as a percent of revenue. How do we compare to last month?",
  overtimeByDept: "Which department had the highest overtime percentage last month?",
  payrollTrend: "How has our payroll as a percent of revenue trended over the last 3 months?",

  // F&B
  fnbDowWeakness: "Which day of the week has the weakest F&B revenue over the last 90 days?",
  fnbOutletDow: "What's our average revenue by day of the week for each of our F&B outlets over the last 90 days?",
};

export default HIGHLIGHT_PROMPTS;
export { HIGHLIGHT_PROMPTS };
